/*  iceberg-ui  */
import { IconName, IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, Typography } from '@mui/material';
import { FontSizes } from 'application/Shared/Constants';

/* images */
// @ts-expect-error No type definitions available for images/Google_Admin.svg
import { ReactComponent as GoogleAdminLogo } from 'images/Google_Admin.svg';

/*  React  */
import React from 'react';

export interface StyledIconProps {
    /**
     * Optional. Size of the icon.
     */
    size?: number;
    /**
     * Name of the icon.
     */
    src: IconName;
}

const StyledIcon = (props: StyledIconProps) => {
    const { size, src } = props;
    const iconSize = size || FontSizes[2];
    return (
        <IconWithVariant
            src={src}
            size={iconSize}
            wrapperProps={{
                display: 'flex',
                justifyContent: 'flex-start',
                width: '24px'
            }}
        />
    );
};

const GWSIcon = ({ size = FontSizes[2] }: { size?: number }) => (
    <Box width="24px">
        <Typography
            sx={{
                display: 'inline-block',
                lineHeight: 0,
                width: size
            }}
        >
            <GoogleAdminLogo />
        </Typography>
    </Box>
);

export const Icons = {
    AddCircleIcon: <StyledIcon src="AddCircle" />,
    AppleIcon: <StyledIcon src="Apple" />,
    BanCircleIcon: <StyledIcon src="BanCircle" />,
    BlurCircularIcon: <StyledIcon src="BlurCircular" />,
    BraveIcon: <StyledIcon src="Brave" />,
    BrightnessIcon: <StyledIcon src="Brightness" />,
    CheckCircleIcon: <StyledIcon src="CheckCircle" />,
    CheckIcon: <StyledIcon src="Check" />,
    ChromeIcon: <StyledIcon src="Chrome" />,
    ClockIcon: <StyledIcon src="Clock" />,
    CloseCircleIcon: <StyledIcon src="CloseCircle" />,
    CloudDownloadIcon: <StyledIcon src="CloudDownload" />,
    CloudIcon: <StyledIcon src="Cloud" />,
    EdgeIcon: <StyledIcon src="Edge" />,
    FirefoxIcon: <StyledIcon src="Firefox" />,
    GoogleIcon: <StyledIcon size={FontSizes[1]} src="Google" />,
    GroupCircleIcon: <StyledIcon src="GroupCircle" />,
    GWSIcon: <GWSIcon />,
    LaptopIcon: <StyledIcon src="Laptop" />,
    MicrosoftIcon: <StyledIcon size={FontSizes[1]} src="Microsoft" />,
    NotificationIcon: <StyledIcon src="Notification" />,
    OperaIcon: <StyledIcon src="Opera" />,
    QuestionMarkIcon: <StyledIcon src="QuestionMark" />,
    SafariIcon: <StyledIcon src="Safari" />,
    SeverityInformationalIcon: (
        <StyledIcon size={FontSizes[3]} src="SeverityInformational" />
    ),
    SubtractCircleIcon: <StyledIcon src="SubtractCircle" />,
    ValidUserIcon: <StyledIcon src="ValidUser" />,
    VpnLockIcon: <StyledIcon src="VpnLock" />,
    WarningIcon: <StyledIcon src="Warning" />,
    WarningTriangleFilledIcon: <StyledIcon src="WarningTriangleFilled" />,
    WarningTriangleIcon: <StyledIcon src="WarningTriangle" />,
    WindowsIcon: <StyledIcon size={FontSizes[1]} src="Windows" />
};
